/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MetadataSchemaProperty } from './MetadataSchemaProperty';
import {
	MetadataSchemaPropertyFromJSON,
	MetadataSchemaPropertyFromJSONTyped,
	MetadataSchemaPropertyToJSON,
} from './MetadataSchemaProperty';

/**
 * A payload to add properties to a metadata schema. This allows dynamic properties to be added, where each property can have a title and a type (e.g., string, integer).
 * @export
 * @interface AddPropertiesToMetadataSchema
 */
export interface AddPropertiesToMetadataSchema {
	/**
	 * An object where each key represents a property name, and the value defines the property's title and type.
	 * @type {{ [key: string]: MetadataSchemaProperty; }}
	 * @memberof AddPropertiesToMetadataSchema
	 */
	properties: { [key: string]: MetadataSchemaProperty };
}

/**
 * Check if a given object implements the AddPropertiesToMetadataSchema interface.
 */
export function instanceOfAddPropertiesToMetadataSchema(value: object): boolean {
	let isInstance = true;
	isInstance = isInstance && 'properties' in value;

	return isInstance;
}

export function AddPropertiesToMetadataSchemaFromJSON(
	json: any
): AddPropertiesToMetadataSchema {
	return AddPropertiesToMetadataSchemaFromJSONTyped(json, false);
}

export function AddPropertiesToMetadataSchemaFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): AddPropertiesToMetadataSchema {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		properties: mapValues(json['properties'], MetadataSchemaPropertyFromJSON),
	};
}

export function AddPropertiesToMetadataSchemaToJSON(
	value?: AddPropertiesToMetadataSchema | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		properties: mapValues(value.properties, MetadataSchemaPropertyToJSON),
	};
}
